import PropTypes from "prop-types"
import React from "react"
import { Image } from "rebass"

const Logo = props => (
  <Image {...props} width={[`240px`, 1 / 2]} mb={[3, 4, 5]} />
)

Logo.propTypes = {
  logo: PropTypes.string
}

export default Logo



// WEBPACK FOOTER //
// ./src/containers/Hero/Logo.js